import { SVGProps, Ref, forwardRef } from 'react';

export const GlobeOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 15.5h.002c5.624-.001 7.498-3.75 7.498-7.5S13.625.5 8 .5.5 4.25.5 8s1.875 7.5 7.5 7.5M1.926 7.298h3.083c.051-1.974.325-3.883.932-5.173-1.276.31-2.138.91-2.725 1.615-.769.923-1.187 2.17-1.29 3.558m3.083 1.4H1.925c.103 1.39.521 2.638 1.291 3.562.587.704 1.449 1.305 2.725 1.615-.608-1.29-.881-3.201-.932-5.177m1.4 0h3.182c-.042 1.547-.228 2.972-.575 4.015C8.582 14.017 8.145 14.1 8 14.1s-.582-.084-1.016-1.386c-.347-1.044-.533-2.469-.575-4.016m3.182-1.4H6.409c.043-1.546.228-2.969.575-4.012C7.418 1.984 7.855 1.9 8 1.9s.582.084 1.016 1.386c.347 1.043.532 2.466.575 4.012m1.4 1.4c-.05 1.976-.324 3.886-.932 5.177 1.276-.31 2.138-.91 2.725-1.615.77-.924 1.188-2.172 1.29-3.562zm3.083-1.4h-3.083c-.051-1.974-.325-3.883-.932-5.173 1.276.31 2.138.91 2.725 1.615.769.923 1.187 2.17 1.29 3.558"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
GlobeOutlinedSize16Glyph.displayName = 'GlobeOutlinedSize16Glyph';
